export const recurrenceTypes = Object.freeze({
  unknown: 0,
  weekly: 1,
  nthWeekdayOfMonth: 2,
});

export const parseWeekday = (
  weekday: 'SU' | 'MO' | 'TU' | 'WE' | 'TH' | 'FR' | 'SA'
) =>
  ({
    SU: 7,
    MO: 1,
    TU: 2,
    WE: 3,
    TH: 4,
    FR: 5,
    SA: 6,
  })[weekday];

export const formatWeekday = (weekday: 1 | 2 | 3 | 4 | 5 | 6 | 7) =>
  (
    ({
      7: 'SU',
      1: 'MO',
      2: 'TU',
      3: 'WE',
      4: 'TH',
      5: 'FR',
      6: 'SA',
    }) as const
  )[weekday];
